export default "__VITE_ASSET__9e90cf8b__"